import styles from './Solution.module.scss'
import { useRef } from 'react'
import animationStyles from 'components/common/Animation/Animation.module.scss'
import useElementVisible from 'components/common/Animation/useElementVisible'

export interface SolutionDetail {
  title?: string
  subTitle1: string
  text1: string | JSX.Element
  subTitle2: string
  text2: string | JSX.Element
  subTitle3: string
  text3?: string | JSX.Element
  subTitle4?: string
  text4?: string | JSX.Element
  imgSrc1: string
  imgSrc1Width: string
  imgSrc1Height: string
  alt1: string
  name1?: string
  isImg1?: boolean
  imgSrc2: string
  imgSrc2Width: string
  imgSrc2Height: string
  alt2: string
  name2?: string
  isImg2?: boolean
  imgSrc3?: string
  imgSrc3Width?: string
  imgSrc3Height?: string
  alt3?: string
  name3?: string
  isImg3?: boolean
  imgSrc4?: string
  imgSrc4Width?: string
  imgSrc4Height?: string
  alt4?: string
  name4?: string
  isImg4?: boolean
  imgSrc5?: string
  imgSrc5Width?: string
  imgSrc5Height?: string
  alt5?: string
  name5?: string
  isImg5?: boolean
  imgSrc6?: string
  imgSrc6Width?: string
  imgSrc6Height?: string
  alt6?: string
  name6?: string
  isImg6?: boolean
  imgSrc7?: string
  imgSrc7Width?: string
  imgSrc7Height?: string
  alt7?: string
  name7?: string
  isImg7?: boolean
  imgSrc8?: string
  imgSrc8Width?: string
  imgSrc8Height?: string
  alt8?: string
  name8?: string
  isImg8?: boolean
}

export interface SolutionItem {
  sectionTitle: string
  sectionRead: string
  solutions: SolutionDetail[]
}

interface Props {
  SolutionEach: SolutionItem[]
}

const Solution: React.FC<Props> = ({ SolutionEach }) => {
  const animeRef = useRef<HTMLDivElement>(null)
  const isVisible = useElementVisible(animeRef, 0.1)

  return (
    <section
      className={`${styles.solution} ${animationStyles.fade} ${isVisible ? animationStyles.fadeOn : ''}`}
      ref={animeRef}
    >
      {SolutionEach.map((item, index) => (
        <div key={index}>
          <h2 className={styles.sectionTitle}>{item.sectionTitle}</h2>
          <p className={styles.sectionRead}>{item.sectionRead}</p>
          {item.solutions.map((solution, idx) => (
            <section key={idx} className={styles.solutionCts}>
              {solution.title && <h3 className={styles.ctsTitle}>{solution.title}</h3>}
              <div className={styles.solutionInner}>
                <div className={styles.solutionLeft}>
                  {[1, 2, 3, 4].map((i) =>
                    solution[`subTitle${i}`] || solution[`text${i}`] ? (
                      <article className={styles.solutionLeft__box} key={i}>
                        {solution[`subTitle${i}`] && (
                          <h3 className={styles.solutionLeft__box__title}>{solution[`subTitle${i}`]}</h3>
                        )}
                        {solution[`text${i}`] && (
                          <p className={styles.solutionLeft__box__text}>{solution[`text${i}`]}</p>
                        )}
                      </article>
                    ) : null,
                  )}
                </div>
                <div className={styles.solutionRight}>
                  <ul className={styles.solutionRight__item}>
                    {[1, 2, 3, 4, 5, 6, 7, 8].map((i) =>
                      solution[`imgSrc${i}`] ? (
                        <li
                          className={
                            styles.solutionRight__item__list + (solution[`isImg${i}`] ? ` ${styles.widthTwo}` : '')
                          }
                          key={i}
                        >
                          <figure className={styles.solutionRight__item__list__img}>
                            <img
                              src={solution[`imgSrc${i}`]}
                              width={solution[`imgSrc${i}Width`]}
                              height={solution[`imgSrc${i}Height`]}
                              alt={solution[`alt${i}`]}
                            />
                          </figure>
                          {solution[`name${i}`] && (
                            <p className={styles.solutionRight__item__list__name}>{solution[`name${i}`]}</p>
                          )}
                        </li>
                      ) : null,
                    )}
                  </ul>
                </div>
              </div>
            </section>
          ))}
        </div>
      ))}
    </section>
  )
}

export default Solution
